import * as React from "react";
import Welcome from "./Welcome";
import "../styles/app.css";

interface AppProps {
  title?: string;
}

const App: React.FC<AppProps> = () => {
  return (
    <div className="app-container">
      <div className="app-content">
        <Welcome />
      </div>
    </div>
  );
};

export default App;
